import React, { Component } from "react"
import { Table, } from "antd"
import { observer, inject } from "mobx-react"

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.columns = []
  }

  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  render() {
    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props

    const columns = [
      {
        width: "15%",
        title: "账户",
        dataIndex: "username",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "15%",
        title: "机构名称",
        dataIndex: "orgName",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "15%",
        title: "注册邮箱",
        dataIndex: "email",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "15%",
        title: (<div className="ta-l">账户类型</div>),
        className: "ta-l",
        dataIndex: "roleName",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      },
      {
        width: "10%",
        title: (<div className="ta-l">报告份数</div>),
        className: "ta-l",
        dataIndex: "reportCount",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      },
      {
        width: "10%",
        title: (<div className="ta-l">PGS份数</div>),
        className: "ta-l",
        dataIndex: "pgsCount",
        render: (text, record) => {
          return (
            <div>{record.data.pgs}</div>
          )
        }
      },
      {
        width: "10%",
        title: (<div className="ta-l">PGD份数</div>),
        className: "ta-l",
        dataIndex: "pgdCount",
        render: (text, record) => {
          return (
            <div>{record.data.pgd}</div>
          )
        }
      },
      {
        width: "10%",
        title: (<div className="ta-l">AZF份数</div>),
        className: "ta-l",
        dataIndex: "azfCount",
        render: (text, record) => {
          return (
            <div>{record.data.azf}</div>
          )
        }
      },
    ]

    return (
      <div className="wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.reportId}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/preview/bill/containers/DataTable.js